<template>
  <v-dialog v-model="dialog" persistent max-width="1000px">
    <v-card :loading="loading">
      <v-card-title>
        <span class="text-h5">Storico e dettagli</span>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row dense>
            <v-col cols="12">
              <h3>ATTUALE</h3>
              <v-simple-table dense class="mt-1">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">GIACENZA</th>
                      <th class="text-left">QUANTITA'</th>
                      <th class="text-center">LISTINO</th>
                      <th class="text-right">PREZZO L.</th>
                      <th class="text-right">PREZZO</th>
                      <th class="text-right">SCONTO</th> 
                      <th class="text-right"><v-badge dot title="Il valore è modificabile">ACQUISTO</v-badge></th>
                      <th class="text-right">RICARICO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in attuale" :key="index">
                      <td class="text-left">{{ item.giacenza }}</td>
                      <td class="text-left">{{ item.quantita }}</td>
                      <td class="text-center">{{ item.listino }}</td>
                      <td class="text-right">{{ item.prezzoL | euro }}</td>
                      <td class="text-right">{{ item.prezzo | euro }}</td>
                      <td class="text-right">{{ item.sconto | percento }}</td>
                      <td class="text-right">
                        <v-edit-dialog :return-value.sync="item.acquisto" large persistent cancel-text="Annulla" save-text="Salva" @save="onSaveAcquisto(item)">
                          {{ item.acquisto | euro }}
                          <template v-slot:input>
                            <div class="mt-4 text-h6">Prezzo acquisto</div>
                            <v-text-field v-model="item.acquisto" label="Valore" single-line autofocus :rules="[numerico]"></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-right">{{ item.ricarico | percento }}</td>
                    </tr>
                  </tbody>                
                </template>
              </v-simple-table>
            </v-col>            
            <v-col cols="5" class="mt-5">
              <h3>LISTINI</h3>
              <v-data-table :headers="headersPrezzi" :items="prezzi" dense hide-default-footer disable-sort>
                <template v-slot:[`header.prezzo`]="{ header }">
                  <v-badge dot title="Il valore è modificabile">{{header.text}}</v-badge>
                  <div class="text-caption">listino</div>
                </template>
                <template v-slot:[`header.sconto`]="{ header }">
                  <v-badge dot title="Sconto su listino fornitore. Il valore è modificabile">{{header.text}}</v-badge>
                  <div class="text-caption">fornitore</div>
                </template>                
                <template v-slot:[`header.ricarico`]="{ header }">
                  <v-badge dot title="Ricarico su prezzo di acquisto. Il valore è modificabile">{{header.text}}</v-badge>
                  <div class="text-caption">acquisto</div>
                </template>
                <template v-slot:[`item.prezzo`]="{ item }">
                  <v-edit-dialog :return-value.sync="item.prezzo" large persistent cancel-text="Annulla" save-text="Salva" @save="onSavePrezzo(item)">
                    <div>{{ item.prezzo | euro}}</div>
                    <template v-slot:input>
                      <div class="mt-4 text-h6">Prezzo listino</div>
                      <v-text-field v-model="item.prezzo" label="Valore" single-line autofocus :rules="[numerico]"></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>
                <template v-slot:[`item.sconto`]="{ item }">
                  <v-edit-dialog :return-value.sync="item.sconto" large persistent cancel-text="Annulla" save-text="Salva" @save="onSaveSconto(item)">
                    <div>{{ item.sconto | euro}}</div>
                    <template v-slot:input>
                      <div class="mt-4 text-h6">Sconto su fornitore</div>
                      <v-text-field v-model="item.sconto" label="Valore" single-line autofocus :rules="[numerico]"></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>                
                <template v-slot:[`item.ricarico`]="{ item }">
                  <v-edit-dialog :return-value.sync="item.ricarico" large persistent cancel-text="Annulla" save-text="Salva" @save="onSaveRicarico(item)">
                    <div>{{ item.ricarico | percento}}</div>
                    <template v-slot:input>
                      <div class="mt-4 text-h6">Ricarico</div>
                      <v-text-field v-model="item.ricarico" label="Valore" single-line autofocus :rules="[numerico]"></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>
              </v-data-table>
              <h5>* = Listino ivato</h5>
            </v-col>
            <v-spacer></v-spacer> 
            <v-col cols="6" class="mt-5">
              <h3>ACQUISTI</h3>
              <v-simple-table dense class="mt-1">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">FORNITORE</th>
                      <th class="text-right">QUANTITA'</th>
                      <th class="text-right">PREZZO</th>
                      <th class="text-right">ULTIMO ACQUISTO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in fornitori" :key="item._id">
                      <td class="text-left">{{ item.fornitore.descrizione }}</td>
                      <td class="text-right">{{ item.quantita }}</td>
                      <td class="text-right">{{ item.prezzo | euro }}</td>
                      <td class="text-right">{{ item.data | date }}</td>
                    </tr>
                  </tbody>             
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="12" class="mt-5">
              <h3>VENDITE AL CLIENTE</h3>
              <v-simple-table dense class="mt-1">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">DATA</th>
                      <th class="text-right">QUANTITA'</th>
                      <th class="text-center">LISTINO</th>
                      <th class="text-right">PREZZO L.</th>
                      <th class="text-right">PREZZO</th>
                      <th class="text-right">SCONTO</th> 
                      <th class="text-right">ACQUISTO</th> 
                      <th class="text-right">RICARICO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in vendite" :key="item._id">
                      <td class="text-left">{{ item.data | date }}</td>
                      <td class="text-right">{{ item.quantita }}</td>
                      <td class="text-center">{{ item.listino }}</td>
                      <td class="text-right">{{ item.prezzoL | euro }}</td>
                      <td class="text-right">{{ item.prezzo | euro }}</td>
                      <td class="text-right">{{ item.sconto | percento }}</td>
                      <td class="text-right">{{ item.acquisto | euro }}</td>
                      <td class="text-right">{{ item.ricarico | percento }}</td>
                    </tr>
                  </tbody>               
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.stop="dialog = false">OK</v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="timeout" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn  color="blue" text v-bind="attrs" @click="snackbar = false">
          OK
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>  
</template>

<script>
  import _ from 'lodash'
  import configurazioni from '@/services/configurazioniService'
  import movimenti from '@/services/movimentiService'
  import prodotti from '@/services/prodottiService'
  export default {
    components: {

    },
    props: {
      cliente: Object,
      prodotto: Object,
      show: Boolean
    },
    data () {
      return {
        fornitori: [],
        prezzi: [],
        vendite: [],
        listini: [],
        listinoAcquisto: null,
        attuale: [],
        dialog: false,
        loading: false,
        headersPrezzi: [
          { text: 'LISTINO', value: 'listino', align: 'start' },
          { text: 'PREZZO', value: 'prezzo', align: 'end' },
          /* { text: 'SCONTO', value: 'sconto', align: 'end' }, */  // TODO: Completare la gestione
          { text: 'RICARICO', value: 'ricarico', align: 'end' }
        ],
        numerico: value => !isNaN(value) || 'Il valore deve essere numerico',
        snackbar: false,
        snackColor: '',
        snackText: '',
        timeout: 4000        
      }
    },
    async mounted() {
      // this.listini = await configurazioni.getConfigurazione('listini', 'listini')
      const conf = await configurazioni.getConfigurazione('listini')
      this.listini = conf.listini
      this.listinoAcquisto = conf.acquisto || { ivato: false }      
    },
    watch: {
      async show(value) {
        if (value) {
          this.dialog = true
          await this.elaboraTabelle()
        }
      }
    },
    methods: {
      async onSaveAcquisto(item) {
        const valore = isNaN(item.acquisto) ? '' : +parseFloat(item.acquisto).toFixed(2)
        await this.aggiornaPrezzo(item, valore, 'acquisto')
      },
      async onSavePrezzo(item) {
        const valore = isNaN(item.prezzo) ? '' : +parseFloat(item.prezzo).toFixed(2)
        await this.aggiornaPrezzo(item, valore)
      },
      async onSaveRicarico(item) {
        let valore = ''
        if (!isNaN(item.ricarico)) {
          const ricarico = +parseFloat((item.ricarico) / 100).toFixed(2)
          valore = item.acquisto * (ricarico + 1)
        }
        await this.aggiornaPrezzo(item, valore)
      },
      async onSaveSconto(item) {
        // TODO: Completare
        const valore = isNaN(item.sconto) ? '' : +parseFloat(item.sconto).toFixed(2)
        // await this.aggiornaPrezzo(item, valore)
      },
      async aggiornaPrezzo(item, valore, tipoPrezzo = 'listino') {
        prodotti.clearCache()
        const idProdotto = _.get(this.prodotto,'appoggio.prodotto.id', _.get(this.prodotto, 'prodotto.codice', ''))
        // const valore = isNaN(item.prezzo) ? '' : +parseFloat(item.prezzo).toFixed(2)
        if (!idProdotto || ! valore) {
          this.snackColor = 'red accent-2'
          this.snackText = 'Il valore non è valido'
          this.snackbar = true
          return
        }
        // considero sempre codiceListino perchè la chiave è completa anche se cliente (es _L_codicexxx, _LT_tipoyyyy) o tipoCliente
        await prodotti.aggiornaPrezzo(tipoPrezzo, idProdotto, item.codiceListino, valore)
        await this.elaboraPrezzi()
        await this.elaboraAttuale()
        this.$emit('aggiornaPrezzo', { listino: item.codiceListino, valore, codice: idProdotto })
        this.snackColor = 'success'
        this.snackText = 'Il prezzo di listino è stato aggiornato'
        this.snackbar = true
      },
      async elaboraTabelle() {
        this.loading = true
        await this.elaboraAttuale()
        await this.elaboraFornitori()
        await this.elaboraPrezzi()
        await this.elaboraVenditeCliente()
        this.loading = false
      },
      async elaboraAttuale() {
        const attuale = []
        const p = this.prodotto
        const c = this.cliente
        const prodotto = await prodotti.getProdotto(p.prodotto.codice)
        const quantita = p.quantita ? +parseFloat(p.quantita).toFixed(2) : ''
        const acquisto = _.get(prodotto, 'magazzino.prezzoAcquisto', 0)
        const giacenza = _.get(prodotto, 'magazzino.giacenza', 0)
        const ivato = _.get(p, 'valore.listino.ivato', false)
        let prezzoL = +parseFloat(_.get(p, 'valore.prezzoNettoUnitario', 0)).toFixed(2)
        let prezzoV = +parseFloat(_.get(p, 'valore.importoNettoUnitario', 0)).toFixed(2)
        if (ivato) {
          prezzoL = +parseFloat(_.get(p, 'valore.prezzoUnitario', 0)).toFixed(2)
          prezzoV = +parseFloat(_.get(p, 'valore.importoUnitario', 0)).toFixed(2)
        }
        const listino = _.get(p, 'valore.listino.descrizione', '')
        const scontoEuro = +(prezzoL - prezzoV).toFixed(2)
        const sconto = +((1 - prezzoV / prezzoL) * 100).toFixed(2)
        let ricarico = acquisto > 0 && prezzoV > 0 ? ((prezzoV - acquisto) / acquisto) * 100 : '---'
        
        if (ivato) {
          const iva = _.get(prodotto, 'aliquotaIva.valore', 22)
          const prz = prezzoV / (1 + iva / 100)
          ricarico = acquisto > 0 ? +(((prz - acquisto) / acquisto) * 100).toFixed(2) : '---'
        }     
        const riga = {
          quantita: quantita,
          listino: listino,
          prezzoL: prezzoL,
          prezzo: prezzoV,
          sconto: sconto,
          scontoEuro: scontoEuro,
          acquisto: acquisto,
          ricarico: ricarico,
          giacenza: giacenza
        }
        attuale.push(riga)
        this.attuale = attuale
      },
      async elaboraFornitori() {
        if (!this.prodotto) return
        const r = this.prodotto
        const mm = await movimenti.getMovimentiProdottoTipoCliente(r.prodotto.codice, null, 'acquisto')
        const fornitori = []
        for (let m of _.sortBy(mm.rows, 'data').reverse()) {
          const riga = {
            fornitore: m.anagrafica.fornitore,
            quantita: m.quantita,
            prezzo: +(m.valore / m.quantita).toFixed(2),
            data: m.data
          }
          fornitori.push(riga)
        }
        this.fornitori = fornitori
      },
      async elaboraPrezzi() {
        if (!this.prodotto) return
        var r = this.prodotto
        const listini = this.listini
        const prodotto = await prodotti.getProdotto(r.prodotto.codice)
        const acquisto = _.get(prodotto, 'magazzino.prezzoAcquisto', 0)
        const pp = prodotto.prezzo
        const prezzi = []

        for (let listino of listini) { // elenco listini
          let pz = pp[listino.codice]
          if (pz) {
            const base = pz.base ? +parseFloat(pz.base).toFixed(2) : 0
            let ricarico = acquisto > 0 && pz.base ? +(((base - acquisto) / acquisto) * 100).toFixed(2) : '---'
            const iva = _.get(r, 'aliquotaIva.valore', 22)
            // Dovrei mostrare entrambi i prezzi, ma diventa un problema per quale è modificabile, perchè cambia in base al listino
            let netto = listino.ivato ? base / (1 + iva / 100) : base
            let lordo = listino.ivato ? base : base * (1 + iva / 100)
            if (listino.ivato && !this.listinoAcquisto.ivato) {
              // const iva = _.get(r, 'aliquotaIva.valore', 22)
              let prz = base / (1 + iva / 100)
              ricarico = acquisto > 0 && pz.base ? +(((prz - acquisto) / acquisto) * 100).toFixed(2) : '---'
            }
            const ivato = listino.ivato ? '* ' : ''
            const prezzo = {
              codiceListino: listino.codice,
              listino: ivato + (listino.descrizione || listino.codice),
/*               prezzoNetto: +netto.toFixed(2),
              prezzo: +lordo.toFixed(2), */
              prezzo: pz.base ? base : '',
              ricarico: ricarico,
              acquisto
            }
            prezzi.push(prezzo)
          } else {
            const prezzo = {
              codiceListino: listino.codice,
              listino: listino.descrizione || listino.codice,
              // prezzoNetto: '',              
              prezzo: '',
              ricarico: '',
              acquisto
            }
            prezzi.push(prezzo)
          }
        }

        const elencoPrezzi = Object.keys(pp)
        for (let p of elencoPrezzi.filter(x => !listini.map(l => l.codice).includes(x))) {  // elenco prezzi speciali (no listini)
          let pz = pp[p]
          if (pz) {
            const listino = this.listini.find(x => x.codice === p)
            const ricarico = acquisto > 0 ? +(((pz.base - acquisto) / acquisto) * 100).toFixed(2) : '---'
            const prezzo = {
              codiceListino: p,
              listino: listino ? listino.descrizione : p,
              prezzo: +pz.base.toFixed(2),
              ricarico: ricarico,
              acquisto
            }
            prezzi.push(prezzo)
          }
        }
        // elenco prezzi specifici per il cliente selezionato (deve verificare di non averli già riportati sopra)
        const listinoCliente = `_L_${this.cliente.codice}`
        if (!elencoPrezzi.find(x => x === listinoCliente)) {
            const prezzo = {
              codiceListino: listinoCliente,
              listino: listinoCliente,
              prezzo: '',
              ricarico: '',
              acquisto
            }
            prezzi.push(prezzo)
        }
        const tipologiaCliente = _.get(this.cliente, 'amministrativi.tipologiaCliente.codice','')
        if (tipologiaCliente.length > 0) {
          const listinoTipologia = `_LT_${tipologiaCliente}`
          if (!elencoPrezzi.find(x => x === listinoTipologia)) {
              const prezzo = {
                codiceListino: listinoTipologia,
                listino: listinoTipologia,
                prezzo: '',
                ricarico: '',
                acquisto
              }
              prezzi.push(prezzo)
          }
        }
        this.prezzi = prezzi
      },
      async elaboraVenditeCliente() {
        if (!this.prodotto || !this.cliente) return
        const r = this.prodotto
        const c = this.cliente
        const mm = await movimenti.getMovimentiProdottoTipoCliente(r.prodotto.codice, 'vendita', null, c.codice)
        
        const vendite = []
        for (let m of _.sortBy(mm.rows, 'data').reverse()) {
          var riga, prezzoV, prezzoL, scontoEuro, sconto, acquisto, ricarico, codiceListino, listino
          prezzoV = +(m.valore / m.quantita).toFixed(2)
          if (m.riferimento.tipo === 'scontrino') {
            codiceListino = _.get(m, 'prodotto.listino', '')
            listino = this.listini.find(x => x.codice === codiceListino)
            const ivato = listino.ivato
            if (ivato) {
              prezzoL = +(parseFloat(_.get(m, 'prodotto.prezzoUnitario', prezzoV))).toFixed(2)
            } else {
              prezzoL = +(parseFloat(_.get(m, 'prodotto.prezzoNettoUnitario', prezzoV))).toFixed(2)
            }
            // prezzoL = +(parseFloat(_.get(m, 'prodotto.prezzoUnitario', prezzoV))).toFixed(2)
            scontoEuro = +(prezzoL - prezzoV).toFixed(2)
            sconto = +((1 - prezzoV / prezzoL) * 100).toFixed(2)
            acquisto = +parseFloat(_.get(m, 'prodotto.prezzoAcquisto', 0) || _.get(r, 'appoggio.prodotto.item.magazzino.prezzoAcquisto', 0)).toFixed(2)
            ricarico = acquisto > 0 ? ((prezzoV - acquisto) / acquisto) * 100 : '---'
            if (ivato) {
              const iva = _.get(r, 'aliquotaIva.valore', 22)
              const prz = prezzoV / (1 + iva / 100)
              ricarico = acquisto > 0 ? +(((prz - acquisto) / acquisto) * 100).toFixed(2) : '---'
            }
            riga = {
              data: m.data,
              quantita: m.quantita,
              listino: listino ? listino.descrizione : codiceListino,
              prezzoL: prezzoL,
              prezzo: prezzoV,
              sconto: sconto,
              scontoEuro: scontoEuro,
              acquisto: acquisto,
              ricarico: ricarico
            }
          } else {
            listino = _.get(m, 'prodotto.listino', '')
            const ivato = listino.ivato
            // Nel movimento è riportato solo il prezzo effettivo
/*             if (ivato) { 
              prezzoL = +(parseFloat(_.get(m, 'prodotto.prezzoUnitario', prezzoV))).toFixed(2)
            } else {
              prezzoL = +(parseFloat(_.get(m, 'prodotto.prezzoNettoUnitario', prezzoV))).toFixed(2)
            } */
            prezzoL = +(parseFloat(_.get(m, 'prodotto.prezzoUnitario', prezzoV))).toFixed(2)
            scontoEuro = +(prezzoL - prezzoV).toFixed(2)
            sconto = +((1 - prezzoV / prezzoL) * 100).toFixed(2)
            acquisto = +parseFloat(_.get(m, 'prodotto.prezzoAcquisto', 0) || _.get(r, 'appoggio.prodotto.item.magazzino.prezzoAcquisto', 0)).toFixed(2)
            ricarico = acquisto > 0 ? ((prezzoV - acquisto) / acquisto) * 100 : '---'
            if (ivato) {
              const iva = _.get(r, 'aliquotaIva.valore', 22)
              const prz = prezzoV / (1 + iva / 100)
              ricarico = acquisto > 0 ? +(((prz - acquisto) / acquisto) * 100).toFixed(2) : '---'
            }             
            // this.listini.find(x => x.codice === codiceListino)
            riga = {
              data: m.data,
              quantita: m.quantita,
              listino: listino ? listino.descrizione : '',
              prezzoL: prezzoL,
              prezzo: prezzoV,
              sconto: sconto,
              acquisto: acquisto,
              ricarico: ricarico
            }
          }
          vendite.push(riga)
        }
        this.vendite = vendite
      }      
    }
  }
</script>
